export default __webpack_public_path__ + "static/media/notif_article_submitted.917608df.svg";